import { createStore, del, get, keys, set } from 'idb-keyval';
import type { StorageLike } from '@zibanu/client';
import { whatsAppLink } from './whatsapp';

/** IndexedDB for the client's storage: the outbox, the chosen books, the read cache (spec 3A §6.4). */
const store = createStore('zibanu', 'kv');

export const idbStorage: StorageLike = {
  get: (key) => get(key, store),
  set: (key, value) => set(key, value, store),
  delete: (key) => del(key, store),
  async keys(prefix) {
    return (await keys(store))
      .map(String)
      .filter((k) => k.startsWith(prefix))
      .sort();
  },
};

/** The same IndexedDB store, shaped for TanStack Query's persister (the read cache, spec 3A §6.4). */
export const idbAsyncStorage = {
  getItem: async (key: string) => (await get<string>(key, store)) ?? null,
  setItem: (key: string, value: string) => set(key, value, store),
  removeItem: (key: string) => del(key, store),
};

/** What a session is called in More → Security (3C). Never the person's own words. */
export function deviceLabel(ua: string = navigator.userAgent): string {
  if (/iPhone|iPad/.test(ua)) return 'iPhone';
  if (/Android/.test(ua)) return 'Android phone';
  if (/Macintosh|Windows|Linux|CrOS/.test(ua)) return 'Computer';
  return 'Browser';
}

/** Our WhatsApp chat: Help, Message us, Add a business. We only ever open our own number. */
export function openWhatsApp(number: string | undefined = import.meta.env.VITE_WHATSAPP_NUMBER): void {
  window.open(whatsAppLink(number), '_blank', 'noopener');
}
